import React from "react";
import SitePicture, { clientLogoName } from "../SitePicture";

// White logo card. On devices with a mouse, logos sit in greyscale and
// colour in on hover; touch devices always show full colour.
function ClientLogoCard({ client }) {
  return (
    <div className="group flex h-full flex-col items-center justify-between rounded-2xl border border-gray-200 bg-white p-4 sm:p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-brand-yellow hover:shadow-lg">
      <div className="flex h-20 sm:h-24 w-full items-center justify-center">
        <SitePicture
          name={clientLogoName(client.image)}
          alt="" // the name is printed right below
          sizes="96px"
          className="max-h-20 sm:max-h-24 w-auto object-contain transition duration-300 [@media(hover:hover)]:grayscale [@media(hover:hover)]:opacity-70 group-hover:grayscale-0 group-hover:opacity-100"
        />
      </div>
      <p className="mt-4 text-center text-xs sm:text-sm font-medium text-gray-700 line-clamp-2 group-hover:text-brand-navy">
        {client.name}
      </p>
    </div>
  );
}

export default ClientLogoCard;
